import { render, staticRenderFns } from "./capture-point.vue?vue&type=template&id=18ef46ae&scoped=true&lang=pug&"
import script from "./capture-point.vue?vue&type=script&lang=js&"
export * from "./capture-point.vue?vue&type=script&lang=js&"
import style0 from "./capture-point.vue?vue&type=style&index=0&id=18ef46ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ef46ae",
  null
  
)

/* custom blocks */
import block0 from "./capture-point.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsFormsMoney: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/widgets/forms/money.vue').default,WidgetsFormsInput: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/widgets/forms/input.vue').default,WidgetsFormsButton: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/widgets/forms/button.vue').default,SiteFeefoMini: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/site/feefo-mini.vue').default,ProductsPillCta: require('/home/ubuntu/nuxt/bonkers/releases/20231201105121/components/products/pill-cta.vue').default})
